import { render, staticRenderFns } from "./ServiceButtonCard.vue?vue&type=template&id=070e6311"
import script from "./ServiceButtonCard.vue?vue&type=script&lang=js"
export * from "./ServiceButtonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports